import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Si requieren que el scroll al top sea animado
 * agregar a los global styles la propiedad
 * scroll-behavior: smooth;
 */

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
